<template>
  <div class="batch-flow">
    <div class="container">
      <div class="batch-flow-header">
        <label for="">查看酒桶資訊</label>
        <a href="#" @click.prevent="closeBtnClicked" class="h4 close-btn">
          <b-icon icon="x"></b-icon>
        </a>
      </div>
  
      <div class="batch-body py-4">

        <div>
          <p class="text-center">請掃描酒桶條碼</p>

          <b-input-group>
            <b-form-input ref="keg-input" v-model="inputKegID" placeholder="酒桶編號" v-on:keyup.enter="inputKegKeyEnter"></b-form-input>
            <b-input-group-append>
              <b-button variant="primary" size="sm" :disabled="kegIdInvalid" @click="kegReadBtnClicked">查詢</b-button>
            </b-input-group-append>
          </b-input-group>

          <p class="text-center">每次僅能查詢一個酒桶</p>

        </div>

      </div>

    </div>

    <KegInfoModal v-model="showInfoModal" :keg="keg"></KegInfoModal>
  </div>
</template>

<script>
import commonBusyAndErrorHandling from "@/assets/js/commonBusyAndErrorHandling";
import KegInfoModal from "../modals/KegInfoModal.vue";
export default {
  mixins: [commonBusyAndErrorHandling],
  name: 'SearchQuery',
  data() {
    return {
      step: 1,

      inputKegID: '',
      keg: {},
      showInfoModal: false,
    };
  },
  components: {
    KegInfoModal,
  },
  computed: {
    kegIdInvalid() {
      return this.inputKegID.trim().length === 0;
    }
  },
  async mounted() {
    setTimeout(() => {
      this.$refs['keg-input'].focus();
    }, 100);
  },
  beforeDestroy() {
  },
  methods: {
    closeBtnClicked() {
      this.$bvModal.msgBoxConfirm('確認取消執行中的流程嗎?', {
        title: '確認',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: '離開',
        cancelTitle: '繼續流程',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value) {
          this.$router.push({name: 'kegBatchIndex'});
        }
      })
      .catch(err => {
        // An error occurred
        alert(err);
      });
    },

    async readKeg() {
      const kid = this.inputKegID.trim();
      try {
        const keg = await this.$store.dispatch('api/getKegInfoPromise', {kid});
        
        if (keg === null) {
          this.$bvModal.msgBoxOk(`找不到酒桶! (酒桶編號: ${kid})`, {
            title: '發生錯誤',
            size: 'sm',
            centered: true
          }).then();
          return;
        }
        
        this.keg = Object.assign({}, keg);
        this.showInfoModal = true;
      } catch (error) {
        this.$bvModal.msgBoxOk(`${error.toString()}`, {
          title: '發生錯誤',
          size: 'sm',
          centered: true
        }).then();
        return;
      }
    },
    async inputKegKeyEnter() {
      if (!this.kegIdInvalid) {
        await this.handleAsyncTask(async () => { await this.readKeg()});
      }
    },
    async kegReadBtnClicked() {
      await this.handleAsyncTask(async () => { await this.readKeg()});
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
@import "src/assets/scss/batch";
</style>